import { Map } from 'immutable';
import { actions } from './actions';

export const initialState = new Map({ pinDetails: new Map() });

function updatePinLength(state, employees) {
// check that the passcodes are all of the correct length, or show the next button
  const passcodeLengths = employees.map(user => user.passcode.length);
  const max = Math.max(...passcodeLengths);
  const min = Math.min(...passcodeLengths);
  let pinLength = null;
  let showNext = null;
  if (min !== max) {
    // there is more than one length of pass code in the organization. next button needed.
    pinLength = max;
    showNext = true;
  } else {
    [pinLength] = passcodeLengths;
    showNext = false;
  }

  return state.merge({
    pinDetails: new Map({
      showNext,
      length: pinLength,
    }),
  });
}

export default function reducer(state = initialState, { type, value }) {
  switch (type) {
    case actions.CLEAR:
      return initialState;
    case actions.SET_SETTINGS:
      return state.merge(new Map(value));
    case actions.UPDATE_SETTING:
      return state.set(value.key, value.value);
    case actions.UPDATE_PIN_LENGTH:
      return updatePinLength(state, value);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/settings/organisation/reducer.js